<template>
    <BreadCrumb PageTitle="Detail marché" />
    <ViewMarche/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
      import ViewMarche from "@/components/Marche/ViewMarche.vue";
  
    export default defineComponent({
      name: "ViewMarchePage",
      components: {
        BreadCrumb,
        ViewMarche,
      },
    });
  </script>